module.exports = __webpack_public_path__ + "static/image 103-b9fbced23cca3d76e598fe8020204b3b.png";